import React from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import { formatBytes } from '../../../helpers/formatBytes'
import { isImage } from '../../../helpers/isImage'

import DocumentIcon from '../../Icons/DocumentIcon'
import ImageIcon from '../../Icons/ImageIcon'
import TrashIcon from '../../Icons/TrashIcon'
import CrossIcon from '../../Icons/Cross'
import DownloadIcon from '../../Icons/DownloadIcon'

const ProgressBar = ({totalSize, uploadedSize}) => {
  const progress = totalSize > 0 ? (uploadedSize / totalSize) * 100 : 0
  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressBarContainer}>
        <div className={styles.progressBar} style={{width: `${progress}%`}} />
      </div>
      <div className={styles.progressAction}>
        <div>{Math.floor(progress)}%</div>
        <div className={styles.cancelButton}>
          <CrossIcon />
        </div>
      </div>
    </div>
  )
}

const DocumentItem = ({document, isLast, canManage, onRemove, onDownload}) => {

  const dateFormat = useSelector(state => state.company?.companyInfo?.date_format || 'DD.MM.YY')

  const [formatFile] = document.original_mime_type.split('/').reverse()

  const handleRemove = () => {
    onRemove(document.id)
  }

  const handleDownload = () => {
    onDownload(document.id)
  }

  return (
    <div className={styles.container} style={isLast ? {borderBottom: 'none'} : {}}>
      <div className={styles.documentInfo}>
        {
          isImage(document.original_mime_type)
            ? <ImageIcon />
            : <DocumentIcon color="#0087FF" />
        }
        <div style={{flex: 1}}>
          <div className={styles.name}>{document.original_name}</div>
          <div className={styles.documentDetails}>
            <div>{formatFile}</div>
            <div className={styles.dot} />
            <div>{formatBytes(document.size)}</div>
            <div className={styles.dot} />
            <div>{moment(document.created_at).format(dateFormat.replaceAll('.', '-').replace('YY', 'YYYY'))}</div>
          </div>
        </div>
        {
          !document.uploading
            ? <div className={styles.downloadButton} onClick={handleDownload}>
                <DownloadIcon />
              </div>
            : null
        }
        {
          canManage
            ? <div className={styles.removeButton} onClick={handleRemove}>
                <TrashIcon />
              </div>
            : null
        }
      </div>
      {
        document.uploading
          ? <ProgressBar
              totalSize={document.size}
              uploadedSize={document.progress || 0}  />
          : null
      }
    </div>
  )
}

export default DocumentItem
